import PropTypes from 'prop-types';

import Flux from '../../flux/Flux';
import { postType, postCommentType, getNewLineText } from './FeedHelper';
import FeedPostComments from './FeedPostComments';
import FeedPostStats from './FeedPostStats';
import { getCommonTranslation } from '../../utils/TranslationHelper';
import VXButton from '../SimpleElements/VXButton/VXButton';
import { COLOR_TYPE_CALL_TO_ACTION } from '../SimpleElements/VXButton/ButtonHelper';
import { VXButtonLineConfig } from '../SimpleElements/VXButton/VXButtonConfig';
import VXButtonOutline from '../SimpleElements/VXButton/Presets/VXButtonOutline';
import { VXPay } from '../../utils/VXPay';
import { formatCurrency } from '../../utils/CommonUtils';
import ReloadHelper from '../../utils/ReloadHelper';
import UrlBuilder from '../../utils/UrlBuilder';
import { Component } from 'react';

class FeedPostFooter extends Component {
	constructor(props) {
		super(props);
		this.maxChars = this.props.isMobile || this.props.isOverlay ? 150 : 300;
		this.state = {
			showMoreButton: this.needShowMoreButton(),
			isMore: false,
			maxChars: this.maxChars,
		};

		this.needShowMoreButton = this.needShowMoreButton.bind(this);
		this.onClickVote = this.onClickVote.bind(this);
	}

	needShowMoreButton() {
		if (!this.props.text) {
			return;
		}
		return this.props.text.length > this.maxChars;
	}

	getGuestComment() {
		const guestId = Flux.Guest.getId();
		const guestComments = [];

		[...this.props.comments.nodes].map((item) => {
			if (item.comment.user && parseInt(item.comment.user.id) === guestId) {
				guestComments.push(item.comment);
			}
			if (item.replies && item.replies.length > 0) {
				item.replies.map((reply) => {
					if (reply.user && parseInt(reply.user.id) === guestId) {
						guestComments.push(reply);
					}
				});
			}
		});

		guestComments.sort(function (a, b) {
			return new Date(b.created) - new Date(a.created);
		});

		return guestComments[0];
	}

	canLike() {
		if (Flux.Guest.isLoggedIn() && this.props.paidContent && (!this.props.guestState || !this.props.guestState.bought)) {
			return false;
		}
		switch (this.props.type) {
			case Flux.Constants.Feed.Types.CLIP:
			case Flux.Constants.Feed.Types.HOT_CLIP:
			case Flux.Constants.Feed.Types.FP_HOT_CLIP:
				return !this.props.clip.avsRequired;
			case Flux.Constants.Feed.Types.PHOTO_GALLERY:
			case Flux.Constants.Feed.Types.FP_PHOTO_GALLERY:
			case Flux.Constants.Feed.Types.PHOTOS:
				return this.props.photos.filter((photo) => photo.avsRequired) < 1;
			case Flux.Constants.Feed.Types.TEXT:
				return true;
		}
		return false;
	}

	getTitle() {
		const styles = 'feed-footer__title';
		const title = this.props.title;

		if (this.props.feedType === Flux.Constants.Feed.FeedType.PROFILE) {
			if (this.props.isMobile) {
				return <h2 className={styles}>{title}</h2>;
			}

			return <h3 className={styles}>{title}</h3>;
		}

		return <div className={styles}>{title}</div>;
	}

	showStats() {
		return ![Flux.Constants.Feed.Types.CONTEST].includes(this.props.type);
	}

	showComments() {
		return ![Flux.Constants.Feed.Types.CONTEST].includes(this.props.type);
	}

	showVote() {
		return [Flux.Constants.Feed.Types.CONTEST].includes(this.props.type);
	}

	onClickVote(e) {
		ReloadHelper.reload(UrlBuilder.buildContestDetailRoute(this.props.contest.id), e);
	}

	render() {
		let text = '';
		if (this.props.text) {
			const origText = getNewLineText(this.props.text);
			const handler =
				this.state.showMoreButton &&
				`<span class="feed-footer__text-more">
							${this.state.isMore ? getCommonTranslation('show-less') : getCommonTranslation('show-more')}
							</span>`;
			text = this.state.showMoreButton
				? (!this.state.isMore ? origText.substring(0, this.state.maxChars) + '...' : origText) + handler
				: origText;
		}

		return (
			<div
				className={
					'feed-footer' +
					(this.props.isOverlay ? ' feed-footer--overlay' : '') +
					(this.props.type === Flux.Constants.Feed.Types.TEXT ? ' feed-footer--text' : '')
				}
			>
				{this.props.tippingGoal && this.props.tippingGoal.achieved && (
					<div className={'feed-footer__tipping-goal'}>
						<div className={'feed-tipping_goal-progress-wrapper'}>
							{getCommonTranslation('tippinggoal-reached2')}
							<div className={'h-ml-10 feed-tipping_goal-progress'} style={{ width: 'fitContent' }}>
								{formatCurrency(this.props.tippingGoal.goalCoins)}
							</div>
						</div>
					</div>
				)}
				{this.showVote() && (
					<div className={'feed-footer__vote'} onClick={this.onClickVote}>
						<span>{getCommonTranslation('vote-here')}</span> <i className="icon -icon-single-arrow-right-line" />
					</div>
				)}
				{(this.props.title || this.props.text || this.props.isOverlay) && (
					<div className="feed-footer__title-wrapper">
						{this.getTitle()}
						{(this.props.text || this.props.isOverlay) && (
							<div
								className={'feed-footer__text' + (this.props.isOverlay ? ' feed-footer__text--overlay' : '')}
								dangerouslySetInnerHTML={{ __html: text }}
								onClick={() => this.setState({ isMore: !this.state.isMore })}
							></div>
						)}
					</div>
				)}
				{!this.props.isOverlay && this.showStats() && (
					<FeedPostStats {...this.props} canLike={this.canLike()} guestComment={this.getGuestComment()} />
				)}
				{Flux.Guest.isLoggedIn() && this.showComments() && (
					<FeedPostComments {...this.props} canLike={this.canLike()} guestComment={this.getGuestComment()} />
				)}
				{!Flux.Guest.isLoggedIn() && this.props.isOverlay && (
					<div className="feed-comment__login">
						<div>
							<VXButton
								line1={[
									new VXButtonLineConfig(getCommonTranslation('sign-up-for-free-1').toUpperCase()),
									new VXButtonLineConfig(getCommonTranslation('sign-up-for-free-2').toUpperCase(), { bold: true }),
								]}
								color={COLOR_TYPE_CALL_TO_ACTION}
								onClick={VXPay.openSignup}
								icon={'-icon-user-full'}
							/>
						</div>
						<div>
							<VXButtonOutline line1={[new VXButtonLineConfig('LOGIN')]} onClick={VXPay.openLogin} icon={'-icon-user-full'} />
						</div>
					</div>
				)}
			</div>
		);
	}
}

FeedPostFooter.propTypes = {
	isOverlay: PropTypes.bool,
	isMobile: PropTypes.bool,
	hasLiked: PropTypes.bool,
	isRecommended: PropTypes.bool,
	comments: PropTypes.shape(postCommentType),
	feedType: PropTypes.string,
	...postType,
};

FeedPostFooter.defaultProps = {
	likes: 0,
	comments: [],
	isMobile: false,
	isRecommended: false,
};

export default FeedPostFooter;
